import { jsonp, ajax } from '@ifeng/ui_base';

const getStarCount = key => {
    return jsonp(`https://survey.news.ifeng.com/api/getaccumulator?format=js&key=${key}&callback=getStarCount_${key}`, {
        jsonpCallback: `getStarCount_${key}`,
    });
};

const putStarCount = key => {
    return jsonp(`https://survey.news.ifeng.com/api/accumulator?format=js&key=${key}&callback=putStarCount`, {
        jsonpCallback: 'putStarCount',
    });
};

export { getStarCount, putStarCount };
